import {
  TextField as AriaTextField,
  type TextFieldProps as AriaTextFieldProps,
  FieldError,
  Input,
  Label,
  Text,
} from "react-aria-components";
import { tv } from "tailwind-variants";
import { composeTailwindRenderProps, focusRing } from "./primitive";

const textFieldStyles = tv({
  base: "flex flex-col gap-1",
});

const inputStyles = tv({
  extend: focusRing,
  base: "rounded-lg border border-input bg-bg px-3 py-2 text-fg shadow-sm transition-colors",
  variants: {
    isFocused: {
      true: "border-ring ring-1 ring-ring",
    },
    isInvalid: {
      true: "border-danger bg-bg text-fg",
    },
    isDisabled: {
      true: "cursor-default opacity-50",
    },
  },
});

const labelStyles = tv({
  base: "text-sm font-medium text-fg",
});

export interface TextFieldProps extends AriaTextFieldProps {
  label?: string;
  description?: string;
  errorMessage?: string;
}

export function TextField({
  label,
  description,
  errorMessage,
  className,
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField
      className={composeTailwindRenderProps(
        className as string | undefined,
        textFieldStyles(),
      )}
      {...props}
    >
      {label && <Label className={labelStyles()}>{label}</Label>}
      <Input className={inputStyles} />
      {description && (
        <Text slot="description" className="text-xs text-muted-fg">
          {description}
        </Text>
      )}
      <FieldError className="text-xs text-danger">{errorMessage}</FieldError>
    </AriaTextField>
  );
}
